import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GiftState {
  gifts: any[];
  loading: boolean;
  error: string | null;
}

const initialState: GiftState = {
  gifts: [],
  loading: false,
  error: null,
};

const giftSlice = createSlice({
  name: 'gift',
  initialState,
  reducers: {
    fetchGiftsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchGiftsSuccess: (state, action: PayloadAction<any[]>) => {
      state.gifts = action.payload;
      state.loading = false;
    },
    fetchGiftsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchGiftsStart, fetchGiftsSuccess, fetchGiftsFailure } = giftSlice.actions;
export default giftSlice.reducer;
